<div class="offerPreview" *ngIf="offer">
  <div class="offerPreview-pdf">
    <app-pdf-preview
      [offerTitle]="offerTitle"
      [offerDocumentId]="offer.documentId"
      [offerRevision]="offer.revision"
      [pdfSrc]="pdfSrc"
      [isDealer]="isDealer"
      [offerPrice]="offer?.dealerBuyPrice"
      (pdfReady)="setPdfReady($event)"
    ></app-pdf-preview>
  </div>
  <div class="offerPreview-aside">
    <div class="offerPreview-headline">
      <h2 class="h4">{{ 'MODALS.OFFER_PREVIEW.SEND.STEP_TITLE' | translate}}</h2>
    </div>

    <form *ngIf="formReady" [formGroup]="form" class="offerPreview-form">
      <app-form-row *ngIf="isDealer" [label]="['FORMS.OFFER_PREVIEW.EMAIL'] | translateControl : form | async">
        <app-input-tags
          [mainForm]="form"
          [controlName]="'email'"
          (onAdd)="onAddCustom($event)"
        ></app-input-tags>
      </app-form-row>
      <app-form-row *ngIf="!isDealer && !rfp"
        [label]="['FORMS.OFFER_PREVIEW.CONTACT_PERSON'] | translateControl : form | async">
        <ng-container *ngIf="this.dropdownData.dealers.length; else contactPersonInput">
          <app-dropdown
            id="test1"
            [mainForm]="form"
            [controlName]="'email'"
            [options]="searchOptions"
            [multiple]="true"
            [valueKey]="'value'"
            [labelKey]="'title'"
            [placeholderSearch]="['FORMS.OFFER_PREVIEW.EMAIL'] | translateControl : form | async"
            (onAdd)="onAddDropdown($event)"
            (onClose)="onCloseDropdown($event)"
            (onSearch)="getDropdownData($event)"
          ></app-dropdown>
        </ng-container>
        <ng-template #contactPersonInput>
          <app-input-tags id="test2"
            [mainForm]="form"
            [controlName]="'email'"
            [placeholder]="['FORMS.OFFER_PREVIEW.EMAIL'] | translateControl : form | async"
            (onAdd)="onAddCustom($event)"
          ></app-input-tags>
        </ng-template>
      </app-form-row>
      <app-form-row [label]="['FORMS.OFFER_PREVIEW.EMAIL_TEMPLATE'] | translateControl : form | async">
        <app-dropdown [mainForm]="form" [controlName]="'templates'" [options]="templates" [labelKey]="'name'"
          [valueKey]="'id'">
        </app-dropdown>
      </app-form-row>
      <app-textarea [mainForm]="form" [controlName]="'text'" [layoutMod]="['size_lg']">
      </app-textarea>
    </form>

  </div>
</div>
